interface SavedTemplateCardProps {
  title: string;
  description?: string | null;
  preview: string;
  active: boolean;
  selected?: boolean;
  onSelect: () => void;
  onEdit: () => void;
}

export function SavedTemplateCard({
  title,
  description,
  preview,
  active,
  selected = false,
  onSelect,
  onEdit
}: SavedTemplateCardProps) {
  return (
    <article
      className={`flex h-full min-h-[320px] flex-col rounded-xl border bg-white p-5 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-md ${
        selected ? 'border-blue-400 ring-2 ring-blue-100' : 'border-slate-200'
      }`}
    >
      <button
        type="button"
        onClick={onSelect}
        className="flex flex-1 flex-col text-left"
      >
        <div className="flex items-start justify-between gap-4">
          <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-blue-700">
            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.25 3.75h4.375L15 8.125v8.125H6.25a1.25 1.25 0 0 1-1.25-1.25V5A1.25 1.25 0 0 1 6.25 3.75Z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.625 3.75v4.375H15" />
            </svg>
          </div>

          <div className="flex items-center gap-2">
            <span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${active ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-200 text-slate-600'}`}>
              {active ? 'Ativo' : 'Inativo'}
            </span>
            {selected && (
              <span className="rounded-full bg-blue-100 px-2.5 py-1 text-[11px] font-semibold text-blue-700">
                Selecionado
              </span>
            )}
          </div>
        </div>

        <div className="mt-4">
          <h4 className="text-base font-semibold text-slate-950">{title}</h4>
          <p className="mt-1 text-sm text-slate-500">{description}</p>
        </div>

        <div className="mt-4 rounded-xl bg-slate-50 p-4">
          <p
            className="text-sm leading-6 text-slate-600"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 6,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden'
            }}
          >
            {preview}
          </p>
        </div>
      </button>

      <div className="mt-5 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={onEdit}
          className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50"
        >
          Editar
        </button>
      </div>
    </article>
  );
}
